// extracted by mini-css-extract-plugin
module.exports = {"root":"SurveyFeats_root__72xiH","title":"SurveyFeats_title__Cpkmb","content":"SurveyFeats_content__RYrjO"};